module.exports = __webpack_public_path__ + "static/media/filterIcon.8597bec6.svg";